
    import './styles.scoped.css';
    export default {
  "breadcrumb-group": "awsui_breadcrumb-group_d19fg_zqpde_5",
  "item": "awsui_item_d19fg_zqpde_16",
  "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_zqpde_26",
  "ellipsis": "awsui_ellipsis_d19fg_zqpde_36",
  "icon": "awsui_icon_d19fg_zqpde_44",
  "mobile": "awsui_mobile_d19fg_zqpde_48"
};
  